"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toColorString = _interopRequireDefault(require("polished/lib/color/toColorString"));

var _rem = _interopRequireDefault(require("polished/lib/helpers/rem"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _color = _interopRequireDefault(require("@decisiv/design-tokens/lib/color"));

var _spacing = _interopRequireDefault(require("@decisiv/design-tokens/lib/spacing"));

var _typography = _interopRequireDefault(require("@decisiv/design-tokens/lib/typography"));

var _ChevronDown = _interopRequireDefault(require("@decisiv/iconix/lib/components/ChevronDown"));

var _ChevronUp = _interopRequireDefault(require("@decisiv/iconix/lib/components/ChevronUp"));

var _Times = _interopRequireDefault(require("@decisiv/iconix/lib/components/Times"));

var _styleModifiers = require("../../utils/styleModifiers");

var _useTranslations = _interopRequireDefault(require("../../utils/useTranslations"));

var _BaseButton = _interopRequireDefault(require("../../atoms/BaseButton"));

var _Button = _interopRequireDefault(require("../Button"));

var _Flex = _interopRequireDefault(require("../Flex"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var TargetContainer = _styledComponents.default.div.withConfig({
  displayName: "Target__TargetContainer",
  componentId: "ks9oxf-0"
})(["align-items:center;display:flex;justify-content:space-between;position:relative;top:-2px;width:100%;"]);

var TargetButton = (0, _styledComponents.default)(_BaseButton.default).withConfig({
  displayName: "Target__TargetButton",
  componentId: "ks9oxf-1"
})(["background:transparent;border:transparent;cursor:inherit;font-size:", ";font-weight:", ";height:24px;line-height:140%;margin-right:", "px;overflow:hidden;padding:0;text-align:left;text-overflow:ellipsis;white-space:nowrap;width:100%;&:active,&:focus{outline:none;}"], (0, _rem.default)(_typography.default.size.alias.default), _typography.default.weight.alias.medium, _spacing.default.base * 0.5);
var ExpandedIndicatorContainer = (0, _styledComponents.default)(_Flex.default).attrs({
  alignItems: 'center',
  paddingLeft: 0.7,
  paddingRight: 1
}).withConfig({
  displayName: "Target__ExpandedIndicatorContainer",
  componentId: "ks9oxf-2"
})(["color:", ";&:hover{color:", ";}", ";"], (0, _toColorString.default)(_color.default.interaction.pacificOcean), (0, _toColorString.default)(_color.default.interaction.indianOcean), (0, _styleModifiers.when)('disabled', (0, _styledComponents.css)(["color:", ";&:hover{color:", ";}"], (0, _toColorString.default)(_color.default.opacity.charcoal40), (0, _toColorString.default)(_color.default.opacity.charcoal40))));

function SelectDateTarget(_ref, ref) {
  var children = _ref.children,
      clearButtonLabel = _ref.clearButtonLabel,
      disabled = _ref.disabled,
      hasClearButton = _ref.hasClearButton,
      inputFieldLabel = _ref.inputFieldLabel,
      isPopoverVisible = _ref.isPopoverVisible,
      onClear = _ref.onClear,
      readOnly = _ref.readOnly,
      rest = _objectWithoutProperties(_ref, ["children", "clearButtonLabel", "disabled", "hasClearButton", "inputFieldLabel", "isPopoverVisible", "onClear", "readOnly"]);

  var translate = (0, _useTranslations.default)();
  return _react.default.createElement(TargetContainer, null, _react.default.createElement(TargetButton, _extends({}, rest, {
    type: "button",
    ref: ref
  }), children), hasClearButton && !readOnly && _react.default.createElement(_Button.default, {
    style: {
      padding: 0
    },
    "aria-label": translate(clearButtonLabel, 'selectDate.clearButtonLabel', {
      label: inputFieldLabel
    }),
    disabled: disabled,
    icon: _Times.default,
    intent: "danger",
    onClick: function onClick(event) {
      event.preventDefault();
      event.stopPropagation();

      if (!disabled) {
        onClear && onClear();
      }
    },
    size: "small",
    variant: "ghost"
  }), !readOnly && _react.default.createElement(ExpandedIndicatorContainer, {
    disabled: disabled
  }, isPopoverVisible ? _react.default.createElement(_ChevronUp.default, {
    size: "small"
  }) : _react.default.createElement(_ChevronDown.default, {
    size: "small"
  })));
}

var SelectDateTargetWithRef = (0, _react.forwardRef)(SelectDateTarget);
SelectDateTargetWithRef.displayName = 'SelectDateTarget';
var _default = SelectDateTargetWithRef;
exports.default = _default;